/* Measure blank margins without changing the supplier's image file. */
((root) => {
  function measure(pixels, width, height) {
    const blank = index => pixels[index + 3] < 24 || Math.min(pixels[index], pixels[index + 1], pixels[index + 2]) >= 250;
    let edgeCount = 0, blankEdges = 0;
    for (let y = 0; y < height; y++) for (let x = 0; x < width; x++) {
      if (x < 3 || y < 3 || x >= width - 3 || y >= height - 3) {
        edgeCount++;
        if (blank((y * width + x) * 4)) blankEdges++;
      }
    }
    if (blankEdges / edgeCount < 0.985) return { kind: 'background' };
    let left = width, top = height, right = -1, bottom = -1, count = 0;
    for (let y = 0; y < height; y++) for (let x = 0; x < width; x++) {
      if (!blank((y * width + x) * 4)) {
        left = Math.min(left, x); right = Math.max(right, x);
        top = Math.min(top, y); bottom = Math.max(bottom, y); count++;
      }
    }
    if (count < width * height * 0.015 || right <= left || bottom <= top) return { kind: 'review' };
    // Use the subject's dimensions so large supplier margins do not produce smaller products.
    const padX = Math.max(1, Math.ceil((right - left + 1) * 0.025));
    const padY = Math.max(1, Math.ceil((bottom - top + 1) * 0.025));
    left = Math.max(0, left - padX); right = Math.min(width, right + 1 + padX);
    top = Math.max(0, top - padY); bottom = Math.min(height, bottom + 1 + padY);
    return { kind: 'bounds', left: left / width, top: top / height, right: right / width, bottom: bottom / height };
  }
  function fit(bounds, naturalWidth, naturalHeight, frameWidth, frameHeight) {
    if (bounds.kind !== 'bounds' || !naturalWidth || !naturalHeight || !frameWidth || !frameHeight) return null;
    const ratio = Math.min(frameWidth / naturalWidth, frameHeight / naturalHeight);
    const subjectWidth = (bounds.right - bounds.left) * naturalWidth * ratio;
    const subjectHeight = (bounds.bottom - bounds.top) * naturalHeight * ratio;
    // Never enlarge beyond the original pixel size; preserve all measured edges.
    const resolutionLimit = Math.max(1, 1 / ratio);
    const scale = Math.min(2.2, resolutionLimit, frameWidth * 0.92 / subjectWidth, frameHeight * 0.92 / subjectHeight);
    if (scale <= 0 || Math.abs(scale - 1) < 0.015) return null;
    const x = -(bounds.left + bounds.right - 1) * naturalWidth * ratio * scale / 2;
    const y = -(bounds.top + bounds.bottom - 1) * naturalHeight * ratio * scale / 2;
    return { scale, x, y };
  }
  const api = { measure, fit };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else root.HivisImageBounds = api;
})(typeof window === 'undefined' ? this : window);


